import React, { useMemo, FC } from "react"
import classNames from "classnames"
import styles from "./index.module.scss"
import { Client } from "@/utils/gameAssets"
import { Module } from "@ak/game-assets"
import { i18n, I18nTextPath } from "@/i18n"

interface RealRewardInfoProps {
    reward: {
        src: string
        title: string
    }
}

const RealRewardInfo: FC<RealRewardInfoProps> = ({ reward }) => {
    const title = i18n.get(reward.title as I18nTextPath)
    
    // 根据文本长度确定字号类名
    const textSizeClass = useMemo(() => {
        const textLength = title.length
        if (textLength > 12) {
            return styles.size18 // 18px
        }
        if (textLength > 10) {
            return styles.size20 // 20px
        }
        if (textLength >= 8) {
            return styles.size25 // 25px
        }
        if (textLength > 6) {
            return styles.size32 // 32px
        }
        return undefined // 使用默认字号 40px
    }, [title])
    
    return (
        <div className={styles.realRewardDetail}>
            <div className={styles.giftImg}>
                <img src={reward?.src} alt="" />
            </div>
            <div className={styles.giftName}>
                <div className={classNames(styles.text, textSizeClass)}>
                    {title}
                </div>
            </div>
        </div>
    )
}

export default RealRewardInfo
